import type { ReactNode } from "react";
import { Sidebar } from "@/components/sidebar/Sidebar";
import { TopBar } from "@/components/header/TopBar";
import { Playbar } from "@/components/playbar/Playbar";
import { BottomNav } from "@/components/nav/BottomNav";
import { ContextMenu } from "@/components/context-menu/ContextMenu";
import { usePlaybackSync } from "@/hooks/usePlaybackSync";
import { useScrollRestoration } from "@/hooks/useScrollRestoration";

export function MainLayout({ children }: { children: ReactNode }) {
  usePlaybackSync();
  useScrollRestoration();
  return (
    <div className="app-shell">
      <div className="sidebar"><Sidebar /></div>
      <div className="topbar"><TopBar /></div>
      <main className="main">{children}</main>
      <div className="playbar"><Playbar /></div>
      <div className="bottomnav-slot"><BottomNav /></div>
      <ContextMenu />
    </div>
  );
}
